<template>
  <div class="saleLogin">
    <div class="logo">
      艾拉莫德片
    </div>
    <van-field
      class="phone"
      v-model="phone"
      center
      clearable
      label="手机号码"
      placeholder="请输入手机号码"
    >
    </van-field>

    <div class="content-name code-form">
      <!-- <div class="code-item">
        <van-field
          v-model="verification.code"
          placeholder="请输入密码"
          :height="88" type="number"
        />
      </div> -->
         <van-field
      class="code-item"
      v-model="passWord"
      center
      clearable
      label="密码"
      placeholder="请输入您的密码"
    >
    </van-field>
    </div>

    <van-button class="saleLogin-fill" type="default" size="large" @click="login()"
      >登 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;陆</van-button
    >
  </div>
</template>

<script>
/* eslint-disable */
import { Dialog, Button, Popup as VanPopup } from 'vant';
import { Field, CellGroup } from 'vant';
import request from '../../services/doctor';
import saleLogin from '../../services/saleLogin';
import { Toast as VanToast } from 'vant';
import utils from '../../lib/utils';

export default {
  name: 'WangHaiDong',
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Field.name]: Field,
    Button,
    VanPopup,
    VanToast
  },
  data() {
    return {
      phone: undefined,
      verifyCode: undefined,
   passWord:undefined
    };
  },

  methods: {
    createCode() {
      // 手机号自定义验证
      if (!utils.isValue(this.phone)) {
        VanToast.fail('请输入手机号码');
      } else if (this.phone.length !== 11 || !/0?(13|14|15|16|19|18|17)[0-9]{9}/.test(this.phone)) {
        VanToast.fail('请正确输入手机号');
        return;
      }

      // 生成验证码
      // if (!this.phone) {
      //   VanToast('请输入手机号');
      //   return;
      // } else {
      //   saleLogin.getQrCode(this.phone).then(
      //     res => {
      //       this.verification.show = true;
      //       let time = setInterval(() => {
      //         this.verification.time--;
      //         if (this.verification.time < 1) {
      //           this.verification.once = true;
      //           this.verification.show = false;
      //           clearInterval(time);
      //         }
      //       }, 1000);
      //     },
      //     err => {
      //       VanToast('获取验证码失败~');
      //     }
      //   );
      // }
    },
    login() {
      const params = {
        mobile: this.phone,
        // verifyCode: this.verification.code,
        passWord:this.passWord

      };
       if (this.passWord == '') {
        VanToast('请输入密码');
      } else {
        saleLogin.loginIGU(params).then(res => {
          // const id = res.data.data;
          console.log(res);
          if (res.data.code == 200) {
            VanToast.success('登陆成功');

            this.$router.push({
              name: 'IGUList',
              query: { doctorId: res.data.data.doctorId, hospitalId: res.data.data.hospitalId }
            });
          } else {
            this.$toast({
              message: res.data.msg
            });
          }
        });
      }

      // if (this.verification.code == '') {
      //   VanToast('请输入验证码');
      // } else {
      //   saleLogin.loginIGU(params).then(res => {
      //     // const id = res.data.data;
      //     console.log(res);
      //     if (res.data.code == 200) {
      //       VanToast.success('登陆成功');

      //       this.$router.push({
      //         name: 'IGUList',
      //         query: { doctorId: res.data.data.doctorId, hospitalId: res.data.data.hospitalId }
      //       });
      //     } else {
      //       this.$toast({
      //         message: res.data.msg
      //       });
      //     }
      //   });
      // }
    }
  }
};
</script>

<style lang="less" scoped>
body {
  width: 100%;
}
.phone {
  // background-color: ;
  width: 90%;
  position: fixed;
  top: 50%;
  left: 5%;
  border-radius: 6px;
}
.verifyCode {
  width: 90%;
  position: fixed;
  top: 60%;
  left: 5%;
  border-radius: 6px;
}
.saleLogin {
  width: 100vw;
  height: 100vh;
  background-color: #f0f0f0;
}
.saleLogin-fill {
  position: fixed;
  top: 70%;
  left: 5%;
  width: 90%;
  border-radius: 6px;
  color: #208fe3;
  font-size: 18px;
}
.logo {
  width: 100px;
  margin: 0 auto;
  padding-top: 60%;
  font-size: 20px;
}
.form-code {
  margin-top: -15px;
  padding-bottom: 25px;
  border-bottom: none;
}
.content-name {
  border-radius: 6px;
  background: #f5f5f5;
  width: 90%;
  position: fixed;
  top: 60%;
  left: 5%;
  border-radius: 6px;
}
.content-name.code-form {
  z-index: 200;
  border: none;
  // background: #fff;

  padding: 0;
  .van-field {
    border: none !important;
    background: #fff;
  }
}
.code-item {
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  .verification {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    background: #208fe3;
    width: 200px;
    height: 46px;
    line-height: 44px;
    text-align: center;
    color: white;
  }
}
</style>
